import { useContext } from 'react';
import { PageResourceContext } from '../provider/PageResourceContextProvider';

const useWebContext = (screenId) => {
  const resource = useContext(PageResourceContext);
  return {
    controlSettings: screenId == null ? null : resource.ControlSettings[screenId],
    messageList: resource.MessageList,
    screenSettings: screenId == null ? null : { ...resource.ScreenSettings[screenId], ...resource.ScreenSettings['Common'] },
    // 2024.9.16 MyMine Version2.0対応 Add Start
    commonFiles: resource.CommonFiles,
    // 2024.9.16 MyMine Version2.0対応 Add End
  };
}
export default useWebContext;